import axiosClient from './axiosClient';
import { TicketTypeModel } from '../Models/ticketTypeModel';

const ticketTypeService = {
  // ---------- Ticket_Type_TBL ----------
  getAll: () => {
    return axiosClient.get('/TicketType')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /TicketType returned 404. Falling back to GET /TicketTypes...");
          return axiosClient.get('/TicketTypes');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(TicketTypeModel.typeToFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (ticketTypeID) => {
    return axiosClient.get(`/TicketType/${ticketTypeID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /TicketType/${ticketTypeID} returned 404. Falling back to GET /TicketTypes/${ticketTypeID}...`);
          return axiosClient.get(`/TicketTypes/${ticketTypeID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketTypeModel.typeToFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = TicketTypeModel.typeToBackend(payload);
    body.ticketTypeId = 0;

    return axiosClient.post('/TicketType', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /TicketType returned 404. Falling back to POST /TicketTypes...");
          return axiosClient.post('/TicketTypes', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketTypeModel.typeToFrontend(raw),
        };
      });
  },

  update: (ticketTypeID, payload) => {
    const body = TicketTypeModel.typeToBackend({ ...payload, ticketTypeID });

    return axiosClient.put('/TicketType', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /TicketType returned 404. Falling back to PUT /TicketTypes...");
          return axiosClient.put('/TicketTypes', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketTypeModel.typeToFrontend(raw),
        };
      });
  },

  remove: (ticketTypeID) => {
    return axiosClient.delete(`/TicketType/${ticketTypeID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /TicketType/${ticketTypeID} returned 404. Falling back to DELETE /TicketTypes/${ticketTypeID}...`);
          return axiosClient.delete(`/TicketTypes/${ticketTypeID}`);
        }
        return Promise.reject(err);
      });
  },

  // ---------- Ticket_Sub_Type_TBL ----------
  getSubTypes: (ticketTypeID) => {
    return axiosClient.get(`/TicketSubType/GetByTicketTypeId/${ticketTypeID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET sub-types for ID ${ticketTypeID} returned 404. Trying fallback /TicketSubTypes...`);
          return axiosClient.get('/TicketSubType');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(TicketTypeModel.subTypeToFrontend);
        return {
          data: mappedList,
        };
      });
  },

  createSubType: (ticketTypeID, payload) => {
    const body = TicketTypeModel.subTypeToBackend({ ...payload, ticketTypeID });
    body.subTypeId = 0;

    return axiosClient.post('/TicketSubType', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /TicketSubType returned 404. Falling back to POST /TicketSubTypes...");
          return axiosClient.post('/TicketSubTypes', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketTypeModel.subTypeToFrontend(raw),
        };
      });
  },

  removeSubType: (subTypeID) => {
    return axiosClient.delete(`/TicketSubType/${subTypeID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /TicketSubType/${subTypeID} returned 404. Falling back to DELETE /TicketSubTypes/${subTypeID}...`);
          return axiosClient.delete(`/TicketSubTypes/${subTypeID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default ticketTypeService;
